









import { Component, Prop, Mixins } from "vue-property-decorator";
import { IContract, IContractProduct } from "@/models/contracts";
import RequestPromises from "@/mixins/requestPromises";

@Component({
  components: {
    "credit-notes-table": () =>
      import("@/components/app/global/creditNotes/creditNotesTable.vue")
  }
})
export default class ContractProductCreditNotes extends Mixins(
  RequestPromises
) {
  // Props
  @Prop({ default: "" })
  public clientId!: IContract["client_id"];
  @Prop({ required: true })
  public contractId!: IContract["id"];
  @Prop({ required: true })
  public productId!: IContractProduct["id"];
}
